import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import InputSearch from "../../../components/InputSearch/InputSearch";
import Typography from "../../Typography";
import Table from "../../table/Table";
import UserTreatment from "./Drawer/UserTreatment/UserTreatment";
import UserHistory from "./Drawer/UserHistory/UserHistory";
import UserInteraction from "./Drawer/UserInteraction/UserInteraction";
import DealingTag from "./DealingTag/DealingTag";
import Paperplane from "../../Loading/Paperplane/Paperplane";
import PopoverColumnsFilter from "../../../components/popovercolumnsfilter/PopoverColumnsFilter";

import { ReactComponent as EmptyState } from "../../../build/images/emptystatemanagerhorizontal.svg";
import { ReactComponent as ColumnFilterIcon } from "../../../build/images/icons/ColumnFilterIcon.svg";

import "./dealing.css";
import Comment from "./Drawer/Comment/Comment";
import CaseDealing from "./Drawer/CaseDealing/CaseDealing";
import {
  getDealCall,
  getDealCallCount,
  getDealCallCountCSAT,
  getDealCallPagineted,
  getDealCallPaginetedCSAT,
  getFilterConceptCsat,
  getViewTypeEvaluation,
  updateDealCall,
  updateDealCallCount,
  updateDealCallCountCSAT,
  updateDealCallPagineted,
  updateDealCallPaginetedCSAT,
} from "../../../actions";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "react-toastify";
import TableBackPagination from "../../TableBackPagination";
import InputSearchBackPagination from "../../InputSearchBackPagination";
import MenuTabs from "../../MenuTabs";
import FilterChips from "../../FilterChips";

let exhibColumn = [];

const Dealing = () => {
  /**
   * PERFIL: Se a nota for de 1 a 6, será Detrator(vermelho).
   * Se a nota for 7 e 8, será Neutro(amarelo). Se a nota for
   * 9 e 10, será Promotor(verde)
   */

  const columnsDealing = useSelector((state) => state.columnsDealingAgent);
  const agentDashboardFilter = useSelector(
    (state) => state.agentDashboardFilter
  );
  const [searchData, setSearchData] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [userHistoryDrawer, setUserHistoryDrawer] = useState(false);
  const [visibleDrawerCase, setVisibleDrawerCase] = useState(false);
  const [visibleDrawerComment, setVisibleDrawerComment] = useState(false);
  const [userInteractionDrawer, setUserInteractionDrawer] = useState(false);
  const [loading, setLoading] = useState(true);
  const [hiddenDrawerTreatment, setHiddenDrawerTreatment] = useState(false);
  const [dataMsg, setDataMsg] = useState([]);
  const [treatmentData, setTreatmentData] = useState([]);
  const [filteredTreatmentData, setFilteredTreatmentData] = useState([]);
  const [cdrId, setCdrId] = useState(null);
  const [caseId, setCaseId] = useState(null);
  const [errorTreatmentData, setErrorTreatmentData] = useState(false);

  const [totalOfRows, setTotalOfRows] = useState(0);
  const [rowsPage, setRowsPage] = useState(() => {
    const storagedRowsPage = window.localStorage.getItem(
      "rowsPageDeallCallCenter"
    );
    const hasStoragedRowsPage =
      (!!storagedRowsPage || storagedRowsPage === 0) &&
      (!!parseInt(storagedRowsPage, 10) ||
        parseInt(storagedRowsPage, 10) === 0);
    const result = hasStoragedRowsPage ? parseInt(storagedRowsPage, 10) : 10;
    return result;
  });
  const [pageOfTable, setPageOfTable] = useState(0);
  const [filter, setFilter] = useState("");
  const [isLoadingTabs, setIsLoadingTabs] = useState(false);
  const [tabs, setTabs] = useState([]);

  //dados do CSAT
  const [totalOfRowsCSAT, setTotalOfRowsCSAT] = useState(0);
  const [treatmentDataCSAT, setTreatmentDataCSAT] = useState([]);
  const [pageOfTableCSAT, setPageOfTableCSAT] = useState(0);
  const [filteredTreatmentDataCSAT, setFilteredTreatmentDataCSAT] = useState(
    []
  );
  const [filtersCSAT, setFiltersCSAT] = useState([]);
  const [filtersNPS, setFiltersNPS] = useState(getInitalFiltersNps());
  const [loadingCSAT, setLoadingCSAT] = useState(false);
  const [tabSelected, setTabSelected] = useState(0);

  exhibColumn = [
    {
      title: "Avaliação",
      exhib: columnsDealing.avaliation,
    },
    {
      title: "Serviço",
      exhib: columnsDealing.service,
    },
    {
      title: "Atendimento",
      exhib: columnsDealing.attendance,
    },
    {
      title: "Resposta",
      exhib: columnsDealing.response,
    },
    {
      title: "Perfil",
      exhib: columnsDealing.profile,
    },
    {
      title: "Nota NPS/CSAT",
      exhib: columnsDealing.note,
    },
    {
      title: "Atendente",
      exhib: columnsDealing.attendant,
    },
    {
      title: "Grupo",
      exhib: columnsDealing.group,
    },
    {
      title: "Atendente de qualidade",
      exhib: columnsDealing.attendantQuality,
    },
    {
      title: "Contato",
      exhib: columnsDealing.contact,
    },
    {
      title: "Canal",
      exhib: columnsDealing.channel,
    },
    {
      title: "Status",
      exhib: columnsDealing.status,
    },
  ];

  const tableColumns = useMemo(() => {
    const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;
    if (!hasTabs) {
      return [
        {
          Header: "Avaliação",
          accessor: "avaliation",
          id: "avaliation",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Avaliação"),
          disableSortBy: true,
        },
        {
          Header: "Serviço",
          accessor: "service",
          id: "service",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Serviço"),
          disableSortBy: true,
        },
        {
          Header: "Atendimento",
          accessor: "attendance",
          id: "attendance",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Atendimento"),
          disableSortBy: true,
        },
        {
          Header: "Resposta",
          accessor: "response",
          id: "response",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Resposta"),
          disableSortBy: true,
        },
        {
          Header: "Perfil",
          accessor: "profile",
          id: "profile",
          disableFilters: true,
          sortType: profileSorting,
          display: chooseDisplay("Perfil"),
          disableSortBy: true,
        },
        {
          Header: "Nota NPS",
          accessor: "note",
          id: "note",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Nota NPS/CSAT"),
          disableSortBy: true,
        },
        {
          Header: "Atendente",
          accessor: "attendant",
          id: "attendant",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente"),
          disableSortBy: true,
        },
        {
          Header: "Grupo",
          accessor: "group",
          id: "group",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Grupo"),
          disableSortBy: true,
        },
        {
          Header: "Atendente de qualidade",
          accessor: "attendantQuality",
          id: "attendantQuality",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente de qualidade"),
          disableSortBy: true,
        },
        {
          Header: "Contato",
          accessor: "contact",
          id: "contact",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Contato"),
          disableSortBy: true,
        },
        {
          Header: "Canal",
          accessor: "channel",
          id: "channel",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Canal"),
          disableSortBy: true,
        },
        {
          Header: "Status",
          accessor: "status",
          id: "status",
          disableFilters: true,
          sortType: statusSorting,
          display: chooseDisplay("Status"),
          disableSortBy: true,
        },
      ];
    }

    //no caso de estar na aba nps o nome da coluna fica nota NPS
    const isNPS = tabs[tabSelected].id === 1;
    if (isNPS) {
      return [
        {
          Header: "Avaliação",
          accessor: "avaliation",
          id: "avaliation",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Avaliação"),
          disableSortBy: true,
        },
        {
          Header: "Serviço",
          accessor: "service",
          id: "service",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Serviço"),
          disableSortBy: true,
        },
        {
          Header: "Atendimento",
          accessor: "attendance",
          id: "attendance",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Atendimento"),
          disableSortBy: true,
        },
        {
          Header: "Resposta",
          accessor: "response",
          id: "response",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Resposta"),
          disableSortBy: true,
        },
        {
          Header: "Perfil",
          accessor: "profile",
          id: "profile",
          disableFilters: true,
          sortType: profileSorting,
          display: chooseDisplay("Perfil"),
          disableSortBy: true,
        },
        {
          Header: "Nota NPS",
          accessor: "note",
          id: "note",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Nota NPS/CSAT"),
          disableSortBy: true,
        },
        {
          Header: "Atendente",
          accessor: "attendant",
          id: "attendant",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente"),
          disableSortBy: true,
        },
        {
          Header: "Grupo",
          accessor: "group",
          id: "group",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Grupo"),
          disableSortBy: true,
        },
        {
          Header: "Atendente de qualidade",
          accessor: "attendantQuality",
          id: "attendantQuality",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente de qualidade"),
          disableSortBy: true,
        },
        {
          Header: "Contato",
          accessor: "contact",
          id: "contact",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Contato"),
          disableSortBy: true,
        },
        {
          Header: "Canal",
          accessor: "channel",
          id: "channel",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Canal"),
          disableSortBy: true,
        },
        {
          Header: "Status",
          accessor: "status",
          id: "status",
          disableFilters: true,
          sortType: statusSorting,
          display: chooseDisplay("Status"),
          disableSortBy: true,
        },
      ];
    }

    //quando estiver na tab do csat o nome da coluna fica nota CSAT
    const isCSAT = tabs[tabSelected].id === 2;
    if (isCSAT) {
      return [
        {
          Header: "Avaliação",
          accessor: "avaliation",
          id: "avaliation",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Avaliação"),
          disableSortBy: true,
        },
        {
          Header: "Serviço",
          accessor: "service",
          id: "service",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Serviço"),
          disableSortBy: true,
        },
        {
          Header: "Atendimento",
          accessor: "attendance",
          id: "attendance",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Atendimento"),
          disableSortBy: true,
        },
        {
          Header: "Resposta",
          accessor: "response",
          id: "response",
          disableFilters: true,
          sortType: hoursSorting,
          display: chooseDisplay("Resposta"),
          disableSortBy: true,
        },
        {
          Header: "Perfil",
          accessor: "profile",
          id: "profile",
          disableFilters: true,
          sortType: profileSorting,
          display: chooseDisplay("Perfil"),
          disableSortBy: true,
        },
        {
          Header: "Nota CSAT",
          accessor: "note",
          id: "note",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Nota NPS/CSAT"),
          disableSortBy: true,
        },
        {
          Header: "Atendente",
          accessor: "attendant",
          id: "attendant",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente"),
          disableSortBy: true,
        },
        {
          Header: "Grupo",
          accessor: "group",
          id: "group",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Grupo"),
          disableSortBy: true,
        },
        {
          Header: "Atendente de qualidade",
          accessor: "attendantQuality",
          id: "attendantQuality",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Atendente de qualidade"),
          disableSortBy: true,
        },
        {
          Header: "Contato",
          accessor: "contact",
          id: "contact",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Contato"),
          disableSortBy: true,
        },
        {
          Header: "Canal",
          accessor: "channel",
          id: "channel",
          disableFilters: true,
          sortType: defaultSorting,
          display: chooseDisplay("Canal"),
          disableSortBy: true,
        },
        {
          Header: "Status",
          accessor: "status",
          id: "status",
          disableFilters: true,
          sortType: statusSorting,
          display: chooseDisplay("Status"),
          disableSortBy: true,
        },
      ];
    }

    return [
      {
        Header: "Avaliação",
        accessor: "avaliation",
        id: "avaliation",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Avaliação"),
        disableSortBy: true,
      },
      {
        Header: "Serviço",
        accessor: "service",
        id: "service",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Serviço"),
        disableSortBy: true,
      },
      {
        Header: "Atendimento",
        accessor: "attendance",
        id: "attendance",
        disableFilters: true,
        sortType: hoursSorting,
        display: chooseDisplay("Atendimento"),
        disableSortBy: true,
      },
      {
        Header: "Resposta",
        accessor: "response",
        id: "response",
        disableFilters: true,
        sortType: hoursSorting,
        display: chooseDisplay("Resposta"),
        disableSortBy: true,
      },
      {
        Header: "Perfil",
        accessor: "profile",
        id: "profile",
        disableFilters: true,
        sortType: profileSorting,
        display: chooseDisplay("Perfil"),
        disableSortBy: true,
      },
      {
        Header: "Nota NPS",
        accessor: "note",
        id: "note",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Nota NPS/CSAT"),
        disableSortBy: true,
      },
      {
        Header: "Atendente",
        accessor: "attendant",
        id: "attendant",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Atendente"),
        disableSortBy: true,
      },
      {
        Header: "Atendente de qualidade",
        accessor: "attendantQuality",
        id: "attendantQuality",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Atendente de qualidade"),
        disableSortBy: true,
      },
      {
        Header: "Contato",
        accessor: "contact",
        id: "contact",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Contato"),
        disableSortBy: true,
      },
      {
        Header: "Canal",
        accessor: "channel",
        id: "channel",
        disableFilters: true,
        sortType: defaultSorting,
        display: chooseDisplay("Canal"),
        disableSortBy: true,
      },
      {
        Header: "Status",
        accessor: "status",
        id: "status",
        disableFilters: true,
        sortType: statusSorting,
        display: chooseDisplay("Status"),
        disableSortBy: true,
      },
    ];
  }, [tabs, tabSelected, exhibColumn]);
  // const tableColumns = [
  //   {
  //     Header: "Avaliação",
  //     accessor: "avaliation",
  //     id: "avaliation",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Avaliação"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Serviço",
  //     accessor: "service",
  //     id: "service",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Serviço"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Atendimento",
  //     accessor: "attendance",
  //     id: "attendance",
  //     disableFilters: true,
  //     sortType: hoursSorting,
  //     display: chooseDisplay("Atendimento"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Resposta",
  //     accessor: "response",
  //     id: "response",
  //     disableFilters: true,
  //     sortType: hoursSorting,
  //     display: chooseDisplay("Resposta"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Perfil",
  //     accessor: "profile",
  //     id: "profile",
  //     disableFilters: true,
  //     sortType: profileSorting,
  //     display: chooseDisplay("Perfil"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Nota NPS",
  //     accessor: "note",
  //     id: "note",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Nota NPS/CSAT"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Atendente",
  //     accessor: "attendant",
  //     id: "attendant",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Atendente"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Atendente de qualidade",
  //     accessor: "attendantQuality",
  //     id: "attendantQuality",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Atendente de qualidade"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Contato",
  //     accessor: "contact",
  //     id: "contact",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Contato"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Canal",
  //     accessor: "channel",
  //     id: "channel",
  //     disableFilters: true,
  //     sortType: defaultSorting,
  //     display: chooseDisplay("Canal"),
  //     disableSortBy: true,
  //   },
  //   {
  //     Header: "Status",
  //     accessor: "status",
  //     id: "status",
  //     disableFilters: true,
  //     sortType: statusSorting,
  //     display: chooseDisplay("Status"),
  //     disableSortBy: true,
  //   },
  // ];

  function getInitalFiltersNps() {
    const initialValue = [
      {
        id: "",
        label: "Todos",
        active: false,
      },
      {
        id: "PROMOTOR",
        label: "Promotor",
        active: false,
      },
      {
        id: "DETRATOR",
        label: "Detrator",
        active: false,
      },
      {
        id: "NEUTRO",
        label: "Neutro",
        active: false,
      },
    ];

    let treatedFiltersNPS = initialValue;
    const hasStoragedFilter = !!window.localStorage.getItem(
      "filterConceptDealingNPS"
    );
    if (hasStoragedFilter) {
      const storagedValue = window.localStorage.getItem(
        "filterConceptDealingNPS"
      );
      treatedFiltersNPS = initialValue.map((datum) => {
        const hasStoragedValue = !!storagedValue;
        const savedValues = hasStoragedValue ? JSON.parse(storagedValue) : null;
        const hasSavedValues =
          !!savedValues && Array.isArray(savedValues) && savedValues.length > 0;

        if (hasSavedValues) {
          const thisFilterOnStorage = savedValues.find((savedValue) => {
            return savedValue.id === datum.id;
          });
          const hasThisFilterOnStorage = !!thisFilterOnStorage;
          if (hasThisFilterOnStorage) {
            datum.active = thisFilterOnStorage.active;
          }
        }
        return datum;
      });
    } else {
      treatedFiltersNPS = [
        {
          id: "",
          label: "Todos",
          active: true,
        },
        {
          id: "PROMOTOR",
          label: "Promotor",
          active: false,
        },
        {
          id: "DETRATOR",
          label: "Detrator",
          active: false,
        },
        {
          id: "NEUTRO",
          label: "Neutro",
          active: false,
        },
      ];
    }

    return treatedFiltersNPS;
  }

  //função que vai ser ativada dentro do drawer quando for clicado o botão de excluir resposta no CSAT
  async function updateListDealAfterTreatCaseCSATOnClose() {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    //setPageOfTable(0);

    //pega o perfilCSAT que foi selecionado (bom, ruim, ...)
    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = filtersCSAT.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    //volta para a primeira página
    setPageOfTableCSAT(0);

    //atualiza a lista do CSAT
    updateListDealV2CSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      rowsPage,
      filter,
      perfilCSAT
    );
  }

  //função que atualiza a lista ao mudar no drawer o status
  async function updateListDealAfterTreatCaseCSAT() {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    //setPageOfTable(0);

    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = filtersCSAT.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    const isPageOne = pageOfTableCSAT === 0;
    //verifica se a página atual é a primeira página
    if (isPageOne) {
      updateListDealV2CSAT(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        pageOfTableCSAT + 1,
        rowsPage,
        filter,
        perfilCSAT
      );
    } else {
      //verifica se a página atual tem algum dado, se não tiver vai para a anterior
      setErrorTreatmentData(false);
      setLoadingCSAT(true);

      const verifyIfHasDataInThisPage = async (page) => {
        let correctPage = page;
        const isPageOne = page === 0;
        if (isPageOne) {
          return correctPage;
        }

        const response = await updateDealCallCountCSAT(
          dateStart,
          dateEnd,
          idsChannel,
          idsAvaliation,
          filter,
          perfilCSAT
        );

        const hasResponse = !!response && response.status === 200;
        const hasData = hasResponse && !!response.data;
        if (hasResponse && hasData) {
          const data = response.data;
          const pageToComparate = correctPage + 1;
          const maxOfPages = Math.ceil(data.qtde / rowsPage);
          const hasContentInTheCurrentPage = pageToComparate <= maxOfPages;
          if (!hasContentInTheCurrentPage) {
            correctPage = maxOfPages - 1;
          }
        } else {
          correctPage = 0;
        }

        return correctPage;
      };

      const correctPage = await verifyIfHasDataInThisPage(pageOfTableCSAT);
      console.log("correctPage", correctPage);
      setPageOfTableCSAT(correctPage);

      updateListDealV2CSAT(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        correctPage + 1,
        rowsPage,
        filter,
        perfilCSAT
      );
    }
  }

  //função que atualiza a lista de nps quando clica em excluir resposta no drawer
  async function updateListDealAfterTreatCaseOnClose() {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    //setPageOfTable(0);

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    setPageOfTable(0);

    updateListDealV2(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      rowsPage,
      filter,
      perfilNPS
    );
  }

  //função que atualiza a lista de nps quando clica em aceitar resposta ou muda o status no drawer
  async function updateListDealAfterTreatCase() {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    //setPageOfTable(0);

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    const isPageOne = pageOfTable === 0;
    //verifica se a página atual é a primeira página
    if (isPageOne) {
      updateListDealV2(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        pageOfTable + 1,
        rowsPage,
        filter,
        perfilNPS
      );
    } else {
      //verifica se a página atual tem algum dado, se não tiver vai para a anterior
      setErrorTreatmentData(false);
      setLoading(true);

      const verifyIfHasDataInThisPage = async (page) => {
        let correctPage = page;
        const isPageOne = page === 0;
        if (isPageOne) {
          return correctPage;
        }

        const response = await updateDealCallCount(
          dateStart,
          dateEnd,
          idsChannel,
          idsAvaliation,
          filter,
          perfilNPS
        );

        const hasResponse = !!response && response.status === 200;
        const hasData =
          hasResponse &&
          !!response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0;
        if (hasResponse && hasData) {
          const data = response.data;
          const pageToComparate = correctPage + 1;
          const maxOfPages = Math.ceil(Number(data[0].qtde) / rowsPage);
          const hasContentInTheCurrentPage = pageToComparate <= maxOfPages;
          if (!hasContentInTheCurrentPage) {
            correctPage = maxOfPages - 1;
          }
        } else {
          correctPage = 0;
        }

        return correctPage;
      };

      const correctPage = await verifyIfHasDataInThisPage(pageOfTable);
      setPageOfTable(correctPage);

      updateListDealV2(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        correctPage + 1,
        rowsPage,
        filter,
        perfilNPS
      );
    }
  }

  //função que gera o primeiro carregamento da página de tratativas
  async function getAllData(
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    page,
    rowsPage,
    searchData,
    sourceListDeal,
    perfilNPS,
    idsGroup
  ) {
    setIsLoadingTabs(true);
    let updatedTabs = [];
    //pega os tipos de avaliações existentes (nps, csat)
    const responseActiveSearchs = await getViewTypeEvaluation(sourceListDeal);
    const hasResponseActiveSearchs =
      !!responseActiveSearchs && responseActiveSearchs.status === 200;

    //verifica se o fetch dos tipos de pesquisa deu certo
    if (hasResponseActiveSearchs) {
      const activeSearchs = responseActiveSearchs.data;
      const hasActiveSearchs =
        !!activeSearchs &&
        Array.isArray(activeSearchs) &&
        activeSearchs.length > 0;
      if (hasActiveSearchs) {
        updatedTabs = activeSearchs.filter((typeOfSearch) => {
          return typeOfSearch.view_dashboard;
        });

        const hasOnlyOneTab = !!updatedTabs && updatedTabs.length === 1;

        //verifica se tem apenas o NPS
        const isOnlyNPS = hasOnlyOneTab && updatedTabs[0].id === 1;
        if (isOnlyNPS) {
          await getlistDealV2(
            dateStart,
            dateEnd,
            idsChannel,
            idsAvaliation,
            page,
            rowsPage,
            searchData,
            sourceListDeal,
            perfilNPS,
            idsGroup
          );
        }

        //verifica se tem apenas CSAT
        const isOnlyCSAT = hasOnlyOneTab && updatedTabs[0].id === 2;
        if (isOnlyCSAT) {
          await getlistDealV2CSAT(
            dateStart,
            dateEnd,
            idsChannel,
            idsAvaliation,
            page,
            rowsPage,
            searchData,
            sourceListDeal,
            idsGroup
          );
        }

        //verifica se tem tanto CSAT quanto o NPS
        const isNPSAndCSAT = !!updatedTabs && updatedTabs.length === 2;
        if (isNPSAndCSAT) {
          //verifica se tem já uma tab selecionada no localStorage
          const storagedId = window.localStorage.getItem(
            "idSelectedTabCallCenter"
          );
          const hasStoragedId = !!storagedId || storagedId === 0;
          if (hasStoragedId) {
            const indexOfSelectedTab = updatedTabs.findIndex((tabInfo) => {
              const hasIdInTabInfo = !!tabInfo.id || tabInfo.id === 0;
              if (hasIdInTabInfo) {
                return tabInfo.id.toString() === storagedId.toString();
              } else {
                return false;
              }
            });

            const hasIndexOfSelectedTab = indexOfSelectedTab !== -1;
            if (hasIndexOfSelectedTab) {
              setTabSelected(indexOfSelectedTab);
            }
          }
          await Promise.all([
            getlistDealV2(
              dateStart,
              dateEnd,
              idsChannel,
              idsAvaliation,
              page,
              rowsPage,
              searchData,
              sourceListDeal,
              perfilNPS,
              idsGroup
            ),
            getlistDealV2CSAT(
              dateStart,
              dateEnd,
              idsChannel,
              idsAvaliation,
              page,
              rowsPage,
              searchData,
              sourceListDeal,
              idsGroup
            ),
          ]);
        }

        //não tem nenhuma pesquisa
        const isNoSearchs = !!updatedTabs && updatedTabs.length === 0;
      }
      setTabs(updatedTabs);
      setIsLoadingTabs(false);
    } else {
      //setTotalOfRows(updatedTotalOfRows);
      setTabs(updatedTabs);
      //setFilteredTreatmentData(updatedData);
      //setSearchData("");
      const hasError = !!responseActiveSearchs && !!responseActiveSearchs.error;
      if (hasError) {
        const isCanceled = axios.isCancel(responseActiveSearchs.error);
        if (!isCanceled) {
          toast.error("Ocorreu um erro, tente novamente!", { autoClose: 5000 });
          // setErrorTreatmentData(true);
          setIsLoadingTabs(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  function chooseDisplay(nameDisplay) {
    const indexFind = exhibColumn.findIndex(
      (column) => column.title.toLowerCase() === nameDisplay.toLowerCase()
    );

    if (indexFind === -1) {
      return true;
    }
    return exhibColumn[indexFind].exhib;
  }

  function hoursSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (
        objectRowA &&
        objectRowB &&
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const arrDateRowA = objectRowA.split(" ");
        const arrDateRowB = objectRowB.split(" ");
        let dateRowA = "";
        let hourRowA = "";
        let dateRowB = "";
        let hourRowB = "";

        if (arrDateRowA && arrDateRowA.length >= 1) {
          dateRowA = arrDateRowA[0].split("/").reverse().join("/");

          if (arrDateRowA.length >= 2) {
            hourRowA = arrDateRowA[1];
          }
        }

        if (arrDateRowB && arrDateRowB.length >= 1) {
          dateRowB = arrDateRowB[0].split("/").reverse().join("/");

          if (arrDateRowB.length >= 2) {
            hourRowB = arrDateRowB[1];
          }
        }

        const formatedDateRowA = dateRowA + " " + hourRowA;
        const formatedDateRowB = dateRowB + " " + hourRowB;

        if (formatedDateRowA !== " " && formatedDateRowB !== " ") {
          const rawDateFormateRowA = new Date(formatedDateRowA);
          const rawDateFormateRowB = new Date(formatedDateRowB);
          const dateFormateRowA = rawDateFormateRowA
            ? rawDateFormateRowA.getTime()
            : new Date();
          const dateFormateRowB = rawDateFormateRowB
            ? rawDateFormateRowB.getTime()
            : new Date();

          if (dateFormateRowA === dateFormateRowB) return 0;
          if (dateFormateRowA > dateFormateRowB) return -1;
          if (dateFormateRowB > dateFormateRowA) return 1;
        }
      }

      if (
        objectRowA === "" ||
        objectRowA === null ||
        (objectRowA === undefined && objectRowB === "") ||
        objectRowB === null ||
        objectRowB === undefined
      ) {
        return 0;
      }

      if (
        objectRowA === "" ||
        objectRowA === null ||
        objectRowA === undefined
      ) {
        return 1;
      }

      if (
        objectRowB === "" ||
        objectRowB === null ||
        objectRowB === undefined
      ) {
        return -1;
      }
    }

    return 0;
  }

  /*
  function columnWithTippySorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      } else if (
        objectRowA &&
        objectRowB &&
        typeof objectRowA === "object" &&
        typeof objectRowB === "object" &&
        objectRowA.props &&
        objectRowB.props &&
        typeof objectRowA.props === "object" &&
        typeof objectRowB.props === "object" &&
        (objectRowA.props.content || objectRowA.props.content === "") &&
        (objectRowB.props.content || objectRowB.props.content === "")
      ) {
        const contentRowA = objectRowA.props.content;
        const contentRowB = objectRowB.props.content;

        if (
          typeof contentRowA === "string" &&
          typeof contentRowB === "string"
        ) {
          const contentRowALowerCase = contentRowA.toLowerCase();
          const contentRowBLowerCase = contentRowB.toLowerCase();

          if (contentRowALowerCase > contentRowBLowerCase) return -1;
          if (contentRowBLowerCase > contentRowALowerCase) return 1;
        } else if (
          typeof contentRowA === "number" &&
          typeof contentRowB === "number"
        ) {
          if (contentRowA > contentRowB) return -1;
          if (contentRowB > contentRowA) return 1;
        }
      }

      return 0;
    }

    return 0;
  }
*/
  function defaultSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "string" &&
      typeof rowDataB.data === "string"
    ) {
      const objectRowA = rowDataA.data.toLowerCase();
      const objectRowB = rowDataB.data.toLowerCase();

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "number" &&
      typeof rowDataB.data === "number"
    ) {
      const objectRowA = rowDataA.data;
      const objectRowB = rowDataB.data;

      if (objectRowA > objectRowB) return -1;
      if (objectRowB > objectRowA) return 1;
    } else if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      }

      return 0;
    }

    return 0;
  }

  function statusSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const objectRowA = rowDataA.data.props.children;
      const objectRowB = rowDataB.data.props.children;

      if (typeof objectRowA === "number" && typeof objectRowB === "number") {
        if (objectRowA > objectRowB) return -1;
        if (objectRowB > objectRowA) return 1;
      } else if (
        typeof objectRowA === "string" &&
        typeof objectRowB === "string"
      ) {
        const objectRowALowerCase = objectRowA.toLowerCase();
        const objectRowBLowerCase = objectRowB.toLowerCase();

        if (objectRowALowerCase > objectRowBLowerCase) return -1;
        if (objectRowBLowerCase > objectRowALowerCase) return 1;
      } else if (
        objectRowA &&
        objectRowB &&
        objectRowA.props &&
        objectRowB.props &&
        objectRowA.props.value &&
        objectRowB.props.value &&
        typeof objectRowA === "object" &&
        typeof objectRowB === "object"
      ) {
        const childrenObjectRowA = objectRowA.props.value.desc_deal_status
          ? objectRowA.props.value.desc_deal_status
          : "novo";
        const childrenObjectRowB = objectRowB.props.value.desc_deal_status
          ? objectRowB.props.value.desc_deal_status
          : "novo";

        if (
          childrenObjectRowA &&
          childrenObjectRowB &&
          typeof childrenObjectRowA === "string" &&
          typeof childrenObjectRowB === "string"
        ) {
          const childrenObjectRowALowerCase = childrenObjectRowA.toLowerCase();
          const childrenObjectRowBLowerCase =
            childrenObjectRowB.toLocaleLowerCase();

          if (childrenObjectRowALowerCase > childrenObjectRowBLowerCase)
            return -1;
          if (childrenObjectRowBLowerCase > childrenObjectRowALowerCase)
            return 1;
        }
        return 0;
      }

      return 0;
    }
  }

  function profileSorting(rowA, rowB, columnId) {
    const rowDataA = rowA.original[columnId];
    const rowDataB = rowB.original[columnId];

    if (
      rowDataA &&
      rowDataB &&
      typeof rowDataA.data === "object" &&
      typeof rowDataB.data === "object" &&
      rowDataA.data.type &&
      rowDataB.data.type &&
      rowDataA.data.type === "div" &&
      rowDataB.data.type === "div"
    ) {
      const rowAChildren = rowDataA.data.props.children;
      const rowBChildren = rowDataB.data.props.children;

      if (
        rowAChildren &&
        rowBChildren &&
        typeof rowAChildren.props === "object" &&
        typeof rowBChildren.props === "object"
      ) {
        const objectRowA = rowAChildren.props.NpsNote;
        const objectRowB = rowBChildren.props.NpsNote;

        if (typeof objectRowA === "number" && typeof objectRowB === "number") {
          if (objectRowA > objectRowB) return -1;
          if (objectRowB > objectRowA) return 1;
        } else if (
          typeof rowDataA.data === "string" &&
          typeof rowDataB.data === "string"
        ) {
          const objectRowALowerCase = objectRowA.toLowerCase();
          const objectRowBLowerCase = objectRowB.toLowerCase();

          if (objectRowALowerCase > objectRowBLowerCase) return -1;
          if (objectRowBLowerCase > objectRowALowerCase) return 1;
        }

        return 0;
      }

      return 0;
    }
    return 0;
  }

  /*
        {
        caseNumber: "2024052907078",
        service: "Nome do serviço",
        attendance: "04/01/2024 10:27:32",
        response: "13/06/2024 18:02:45",
        nota_nps: 10,
        attendant: "Allan Kardec",
        desc_deal_status: "Concluído",
        id_deal_status: 4,
        id_cdr: 209544,
        class_color: "#008908",
      }
  */

  //função ativada ao mudar a página da tabela do csat
  function handleChangePageCSAT(valueOfPage) {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");

    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = filtersCSAT.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    updateListDealV2CSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      valueOfPage + 1,
      rowsPage,
      filter,
      perfilCSAT
    );
  }

  //função ativada ao mudar a quantidade de resultados por página da tabela do CSAT
  function handleChangeRowsPerPageCSAT(valueOfRowsPerPage) {
    window.localStorage.setItem(
      "rowsPageDeallCallCenter",
      JSON.stringify(valueOfRowsPerPage)
    );
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    setPageOfTableCSAT(0);
    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = filtersCSAT.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    updateListDealV2CSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      valueOfRowsPerPage,
      filter,
      perfilCSAT
    );
  }

  function handleChangePage(valueOfPage) {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    updateListDealV2(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      valueOfPage + 1,
      rowsPage,
      filter,
      perfilNPS
    );
  }

  function handleChangeRowsPerPage(valueOfRowsPerPage) {
    window.localStorage.setItem(
      "rowsPageDeallCallCenter",
      JSON.stringify(valueOfRowsPerPage)
    );
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    setPageOfTable(0);

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    updateListDealV2(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      valueOfRowsPerPage,
      filter,
      perfilNPS
    );
  }

  //função que vai ser ativada quando deixamos o campo de pesquisa vazio depois de digitar algo
  function handleChangeInputSearch(value) {
    const isValueEmpty = value === "";
    if (isValueEmpty) {
      setFilter("");
      const dateStart = format(
        new Date(agentDashboardFilter.initialDateAgenteScreen),
        "yyyy-MM-dd"
      );
      const dateEnd = format(
        new Date(agentDashboardFilter.finalDateAgentScreen),
        "yyyy-MM-dd"
      );
      const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
        .map((option) => option.id)
        .join(",");
      const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
        .map((option) => option.id)
        .join(",");
      setPageOfTable(0);

      let perfilNPS = "";
      const hasFiltersNPS =
        !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
      if (hasFiltersNPS) {
        const activesFiltersNPS = filtersNPS.filter((datum) => {
          return datum.active;
        });
        const hasActivesFiltersNPS =
          !!activesFiltersNPS &&
          Array.isArray(activesFiltersNPS) &&
          activesFiltersNPS.length > 0;
        if (hasActivesFiltersNPS) {
          perfilNPS = activesFiltersNPS[0].id;
        }
      }

      updateListDealV2(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        1,
        rowsPage,
        "",
        perfilNPS
      );

      setPageOfTableCSAT(0);

      let perfilCSAT = "";
      const hasFiltersCSAT =
        !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
      if (hasFiltersCSAT) {
        const activesFiltersCSAT = filtersCSAT.filter((datum) => {
          return datum.active;
        });
        const hasActivesFiltersCSAT =
          !!activesFiltersCSAT &&
          Array.isArray(activesFiltersCSAT) &&
          activesFiltersCSAT.length > 0;
        if (hasActivesFiltersCSAT) {
          perfilCSAT = activesFiltersCSAT[0].id;
        }
      }

      updateListDealV2CSAT(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        1,
        rowsPage,
        "",
        perfilCSAT
      );
    }
  }

  //função quando escrevemos algo na pesquisa e apertamos enter ou clicamos na lupa
  function handleTableDataLookupV2(event) {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    setPageOfTable(0);
    setFilter(event);

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    updateListDealV2(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      rowsPage,
      event,
      perfilNPS
    );

    setPageOfTableCSAT(0);

    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!filtersCSAT && Array.isArray(filtersCSAT) && filtersCSAT.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = filtersCSAT.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    updateListDealV2CSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      rowsPage,
      event,
      perfilCSAT
    );
  }
  function handleTableDataLookup(event) {
    const filteredData = filteredTreatmentData.filter(
      (data) =>
        (data.avaliation !== null &&
          data.avaliation !== "" &&
          data.avaliation
            .toString()
            .toLowerCase()
            .includes(event.toLowerCase())) ||
        (data.caseNumber !== null &&
          data.caseNumber !== "" &&
          data.caseNumber
            .toString()
            .toLowerCase()
            .includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps.toString().includes(event)) ||
        (data.attendant != null &&
          data.attendant !== "" &&
          data.attendant.toLowerCase().includes(event.toLowerCase())) ||
        (data.desc_deal_status != null &&
          data.desc_deal_status !== "" &&
          data.desc_deal_status !== undefined &&
          data.desc_deal_status.toLowerCase().includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 9 || data.nota_nps === 10) &&
          "promotor".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          (data.nota_nps === 7 || data.nota_nps === 8) &&
          "neutro".includes(event.toLowerCase())) ||
        (data.nota_nps != null &&
          data.nota_nps !== "" &&
          data.nota_nps !== undefined &&
          data.nota_nps >= 0 &&
          data.nota_nps <= 6 &&
          "detrator".includes(event.toLowerCase())) ||
        (data.response != null &&
          data.response !== "" &&
          data.response !== undefined &&
          data.response.toLowerCase().includes(event.toLowerCase())) ||
        (data.attendance != null &&
          data.attendance !== "" &&
          data.attendance !== undefined &&
          data.attendance.toLowerCase().includes(event.toLowerCase())) ||
        ((data.desc_deal_status === null || data.desc_deal_status === "Novo") &&
          (data.id_deal_status === null || data.id_deal_status === 1) &&
          "novo".includes(event.toLowerCase())) ||
        (data.data_avaliacao != null &&
          data.data_avaliacao !== "" &&
          data.data_avaliacao !== undefined &&
          data.data_avaliacao.toLowerCase().includes(event.toLowerCase())) ||
        (data.nome_cliente != null &&
          data.nome_cliente !== "" &&
          data.nome_cliente !== undefined &&
          data.nome_cliente.toLowerCase().includes(event.toLowerCase())) ||
        (data.attendantQuality !== null &&
          data.attendantQuality !== "" &&
          data.attendantQuality !== undefined &&
          data.attendantQuality.toLowerCase().includes(event.toLowerCase())) ||
        (data.contact !== null &&
          data.contact !== "" &&
          data.contact !== undefined &&
          data.contact.toLowerCase().includes(event.toLowerCase())) ||
        (data.channel !== null &&
          data.channel !== "" &&
          data.channel !== undefined &&
          data.channel.toLowerCase().includes(event.toLowerCase()))
    );

    setTreatmentData(filteredData);
  }

  const handleRowClick = (id_cdr) => {
    setIsDrawerOpen(false);
    setCdrId(id_cdr);
    setTimeout(() => {
      setIsDrawerOpen(true);
    }, 200);
  };

  //monta os dados na tabela do CSAT
  function refactoryTableListCSAT(data) {
    let newData = [];

    if (!data) throw new Error("Error when fetching data!");

    data.forEach((value) => {
      const refactoredData = {
        caseNumber: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer", color: "#455cc7" }}
            >
              {value.caseNumber ? value.caseNumber : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        avaliation: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.avaliation ? value.avaliation : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        service: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.service ? value.service : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendance: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendance ? value.attendance : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        response: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.response ? value.response : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        profile: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="refactory-table-list-csat__profile"
                style={{ backgroundColor: value.cor_conceito }}
              >
                <span className="profile-tag-content-csat__span" />
                <Typography.H5 weight="500" color="white">
                  {value.conceito}
                </Typography.H5>
              </div>
            </div>
          ),
          config: {
            className: "",
          },
        },
        note: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.nota_nps}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendant: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendant ? value.attendant : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        group: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.nome_grupo ? value.nome_grupo : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendantQuality: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendantQuality ? value.attendantQuality : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        contact: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.contact ? value.contact : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        channel: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.channel ? value.channel : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        status: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <DealingTag value={value} dealStatusId={value.id_deal_status} />
            </div>
          ),
        },
      };

      newData.push(refactoredData);
    });

    return newData;
  }

  function refactoryTableList(data) {
    let newData = [];

    if (!data) throw new Error("Error when fetching data!");

    data.forEach((value) => {
      const refactoredData = {
        caseNumber: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer", color: "#455cc7" }}
            >
              {value.caseNumber ? value.caseNumber : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        avaliation: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.avaliation ? value.avaliation : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        service: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.service ? value.service : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendance: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendance ? value.attendance : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        response: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.response ? value.response : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        profile: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <DealingTag NpsNote={value.nota_nps} type="profile" />
            </div>
          ),
          config: {
            className: "",
          },
        },
        note: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.nota_nps}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendant: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendant ? value.attendant : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        group: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.nome_grupo ? value.nome_grupo : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        attendantQuality: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.attendantQuality ? value.attendantQuality : "--"}
            </div>
          ),
          config: {
            className: "",
          },
        },
        contact: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.contact ? value.contact : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        channel: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              {value.channel ? value.channel : ""}
            </div>
          ),
          config: {
            className: "",
          },
        },
        status: {
          data: (
            <div
              onClick={() => handleRowClick(value.id_cdr)}
              style={{ cursor: "pointer" }}
            >
              <DealingTag value={value} dealStatusId={value.id_deal_status} />
            </div>
          ),
        },
      };

      newData.push(refactoredData);
    });

    return newData;
  }

  const updatelistDeal = async () => {
    setErrorTreatmentData(false);
    setLoading(true);
    let updatedData = [];

    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const response = await updateDealCall(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
          };
        });
      }

      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      setLoading(false);
    } else {
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoading(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  const updateListDealV2 = async (
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    page,
    limit,
    filter,
    perfilNPS
  ) => {
    setErrorTreatmentData(false);
    setLoading(true);
    let updatedData = [];
    let updatedTotalOfRows = 0;

    const responseCount = await updateDealCallCount(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      filter,
      perfilNPS
    );

    const response = await updateDealCallPagineted(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      limit,
      filter,
      perfilNPS
    );
    const hasResponse = !!response && response.status === 200;
    const hasResponseCount = !!response && response.status === 200;
    if (hasResponse && hasResponseCount) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      const dataCount = responseCount.data;
      const hasDataCount =
        !!dataCount && Array.isArray(dataCount) && dataCount.length > 0;
      if (hasData && hasDataCount) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
          };
        });

        updatedTotalOfRows = Number(dataCount[0].qtde);
      }

      setTotalOfRows(updatedTotalOfRows);
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      setLoading(false);
    } else {
      setTotalOfRows(updatedTotalOfRows);
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoading(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  const updateListDealV2CSAT = async (
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    page,
    limit,
    filter,
    filterCSAT
  ) => {
    setErrorTreatmentData(false);
    setLoadingCSAT(true);
    let updatedData = [];
    let updatedTotalOfRows = 0;

    const responseCount = await updateDealCallCountCSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      filter,
      filterCSAT
    );

    const response = await updateDealCallPaginetedCSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      limit,
      filter,
      filterCSAT
    );
    const hasResponse = !!response && response.status === 200;
    const hasResponseCount = !!response && response.status === 200;
    if (hasResponse && hasResponseCount) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      const dataCount = responseCount.data;
      const hasDataCount = !!dataCount;
      if (hasData && hasDataCount) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
            nota_csat: datum.nota_nps ? datum.nota_nps : 0,
          };
        });

        updatedTotalOfRows = Number(dataCount.qtde);
      }

      setTotalOfRowsCSAT(updatedTotalOfRows);
      setTreatmentDataCSAT(updatedData);
      setFilteredTreatmentDataCSAT(updatedData);
      //setSearchData("");
      setLoadingCSAT(false);
    } else {
      setTotalOfRowsCSAT(updatedTotalOfRows);
      setTreatmentDataCSAT(updatedData);
      setFilteredTreatmentDataCSAT(updatedData);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoadingCSAT(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  //pega os dados que montam a aba de CSAT
  const getlistDealV2CSAT = async (
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    page,
    limit,
    filter,
    source,
    idsGroup
  ) => {
    setErrorTreatmentData(false);
    setLoadingCSAT(true);
    let updatedData = [];
    let updatedTotalOfRows = 0;
    let updatedFiltersCSAT = [];
    let perfilCSAT = "";

    //pega os filtros (bom, ruim....)
    const responseFilters = await getFilterConceptCsat();
    const hasResponseFilters =
      !!responseFilters && responseFilters.status === 200;

    if (hasResponseFilters) {
      const dataFilters = responseFilters.data;
      const hasDataFilters =
        !!dataFilters && Array.isArray(dataFilters) && dataFilters.length > 0;
      if (hasDataFilters) {
        const storagedValue = window.localStorage.getItem(
          "filterConceptDealingCSAT"
        );
        updatedFiltersCSAT = dataFilters.map((datum) => {
          datum.label = datum.desc_conceito;
          datum.id = datum.id_conceito;
          const hasStoragedValue = !!storagedValue;
          const savedValues = hasStoragedValue
            ? JSON.parse(storagedValue)
            : null;
          const hasSavedValues =
            !!savedValues &&
            Array.isArray(savedValues) &&
            savedValues.length > 0;
          //verifica se tem filtro selecionado no storage se tiver ativamos ele
          if (hasSavedValues) {
            const thisFilterOnStorage = savedValues.find((savedValue) => {
              return savedValue.id_conceito === datum.id_conceito;
            });
            const hasThisFilterOnStorage = !!thisFilterOnStorage;
            if (hasThisFilterOnStorage) {
              datum.active = thisFilterOnStorage.active;
            } else {
              datum.active = false;
            }
          } else {
            datum.active = false;
          }
          return datum;
        });

        //se não tiver nenhum filtro no storage ele seleciona a opção Todos
        const isAllFalse = updatedFiltersCSAT.every((datum) => {
          return !datum.active;
        });
        if (isAllFalse) {
          updatedFiltersCSAT.unshift({
            id: "",
            label: "Todos",
            active: true,
            desc_conceito: "Todos",
            id_conceito: "",
          });
        } else {
          updatedFiltersCSAT.unshift({
            id: "",
            label: "Todos",
            active: false,
            desc_conceito: "Todos",
            id_conceito: "",
          });
        }

        //pega o valor ativo no filtro do csat para utilizar na chamada da api
        const activesFiltersCSAT = updatedFiltersCSAT.filter((datum) => {
          return datum.active;
        });
        const hasActivesFiltersCSAT =
          !!activesFiltersCSAT &&
          Array.isArray(activesFiltersCSAT) &&
          activesFiltersCSAT.length > 0;
        if (hasActivesFiltersCSAT) {
          perfilCSAT = activesFiltersCSAT[0].id;
        }
      }
    }

    const responseCount = await getDealCallCountCSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      filter,
      source,
      perfilCSAT,
      idsGroup
    );

    const response = await getDealCallPaginetedCSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      limit,
      filter,
      source,
      perfilCSAT,
      idsGroup
    );

    const hasResponse = !!response && response.status === 200;
    const hasResponseCount = !!response && response.status === 200;
    if (hasResponse && hasResponseCount && hasResponseFilters) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      const dataCount = responseCount.data;
      const hasDataCount = !!dataCount;
      if (hasData && hasDataCount) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
          };
        });

        updatedTotalOfRows = Number(dataCount.qtde);
      }

      setTotalOfRowsCSAT(updatedTotalOfRows);
      setTreatmentDataCSAT(updatedData);
      setFilteredTreatmentDataCSAT(updatedData);
      setFiltersCSAT(updatedFiltersCSAT);
      //setSearchData("");
      setLoadingCSAT(false);
    } else {
      setTotalOfRowsCSAT(updatedTotalOfRows);
      setTreatmentDataCSAT(updatedData);
      setFilteredTreatmentDataCSAT(updatedData);
      setFiltersCSAT(updatedFiltersCSAT);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoadingCSAT(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  const getlistDealV2 = async (
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    page,
    limit,
    filter,
    source,
    perfilNPS,
    idsGroup
  ) => {
    setErrorTreatmentData(false);
    setLoading(true);
    let updatedData = [];
    let updatedTotalOfRows = 0;

    const responseCount = await getDealCallCount(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      filter,
      source,
      perfilNPS
    );

    const response = await getDealCallPagineted(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      limit,
      filter,
      source,
      perfilNPS,
      idsGroup
    );
    const hasResponse = !!response && response.status === 200;
    const hasResponseCount = !!response && response.status === 200;
    if (hasResponse && hasResponseCount) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      const dataCount = responseCount.data;
      const hasDataCount =
        !!dataCount && Array.isArray(dataCount) && dataCount.length > 0;
      if (hasData && hasDataCount) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
          };
        });

        updatedTotalOfRows = Number(dataCount[0].qtde);
      }

      setTotalOfRows(updatedTotalOfRows);
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      setLoading(false);
    } else {
      setTotalOfRows(updatedTotalOfRows);
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoading(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  const getlistDeal = async (
    dateStart,
    dateEnd,
    idsChannel,
    idsAvaliation,
    source
  ) => {
    setErrorTreatmentData(false);
    setLoading(true);
    let updatedData = [];

    const response = await getDealCall(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      source
    );
    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const data = response.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        updatedData = data.map((datum) => {
          return {
            ...datum,
            caseNumber: "",
            avaliation: datum.nome_avaliacao ? datum.nome_avaliacao : "",
            attendance: datum.data_avaliacao ? datum.data_avaliacao : "",
            response: datum.data_resposta ? datum.data_resposta : "",
            nota_nps: datum.nota_nps ? datum.nota_nps : 0,
            attendant: datum.atendente_atendimento
              ? datum.atendente_atendimento
              : "",
            desc_deal_status: datum.desc_deal_status,
            id_deal_status: datum.id_deal_status,
            id_cdr: datum.id_cdr,
            class_color: datum.class_color,
            nome_cliente: "",
            numero_cliente: datum.numero_cliente,
            nome_campanha: datum.nome_avaliacao,
            setor: "",
            atendimento: "",
            unidade: "",
            data_atendimento: datum.data_avaliacao,
            id_atendimento: datum.id_atendimento,
            group: datum.nome_grupo,
            attendantQuality: datum.atendente_tratativa
              ? datum.atendente_tratativa
              : "",
            contact: datum.numero_cliente ? datum.numero_cliente : "",
            channel: datum.desc_midia ? datum.desc_midia : "",
            csat: datum.csat,
            service: datum.nome_servico ? datum.nome_servico : "",
          };
        });
      }

      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      setLoading(false);
    } else {
      setTreatmentData(updatedData);
      setFilteredTreatmentData(updatedData);
      //setSearchData("");
      const hasError = !!response && !!response.error;
      if (hasError) {
        const isCanceled = axios.isCancel(response.error);
        if (!isCanceled) {
          setErrorTreatmentData(true);
          setLoading(false);
        }
      }
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  };

  /*
  const getlistDeal = async () => {
    setLoading(true);

    const data = [
      {
        caseNumber: "2024052907078",
        service: "Nome do serviço",
        attendance: "04/01/2024 10:27:32",
        response: "13/06/2024 18:02:45",
        nota_nps: 10,
        attendant: "Allan Kardec",
        desc_deal_status: "Concluído",
        id_deal_status: 1,
        id_cdr: 209544,
        class_color: "#008908",
        nome_cliente: "Nome teste",
        numero_cliente: "75991490038",
        nome_campanha: "Campanha-teste",
        setor: "Imbuí",
        atendimento: "Particular",
        unidade: "Posto 20 - Imbuí",
        data_atendimento: "04/01/2024 10:27:32",
        id_atendimento: "242-1234",
        group: "Grupo teste",
        attendantQuality: "Raimundo Neto",
        csat: JSON.stringify([
          {
            pergunta: "Atendimento",
            resposta: 5,
            subqualificadores: JSON.stringify([]),
          },
          {
            pergunta: "Estrutura",
            resposta: 0,
            subqualificadores: JSON.stringify([
              {
                id_subq: 6,
                desc_subq: "O ambiente não estava limpo/organizado",
              },
              {
                id_subq: 7,
                desc_subq: "As instalações não estavam adequadas",
              },
              {
                id_subq: 9,
                desc_subq: "Dificuldade em encontrar o local",
              },
            ]),
          },
          {
            pergunta: "Serviço",
            resposta: 0,
            subqualificadores: JSON.stringify([
              {
                id_subq: 12,
                desc_subq: "Procedimentos adotados",
              },
              {
                id_subq: 15,
                desc_subq: "Outros serviços",
              },
            ]),
          },
        ]),
      },
    ];
    setTreatmentData(data);
    setFilteredTreatmentData(data);
    setLoading(false);

    setLoading(false);
  };
  */

  const tableData = useMemo(() => {
    if (treatmentData) {
      //  setLoading(false);

      return refactoryTableList(treatmentData);
    }
  }, [treatmentData]);

  const tableDataCSAT = useMemo(() => {
    if (treatmentDataCSAT) {
      //  setLoading(false);

      return refactoryTableListCSAT(treatmentDataCSAT);
    }
  }, [treatmentDataCSAT]);

  /*
  useEffect(() => {
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    setPageOfTable(0);

    if (!searchData) {
      updateListDealV2(
        dateStart,
        dateEnd,
        idsChannel,
        idsAvaliation,
        1,
        rowsPage,
        ""
      );
    }
  }, [searchData]);
  */

  useEffect(() => {
    if (errorTreatmentData) {
      toast.error("Ocorreu um erro, tente novamente mais tarde!", {
        autoClose: 5000,
      });
    }
  }, [errorTreatmentData]);

  /*
  useEffect(() => {
    getlistDeal(
      agentDashboardFilter.initialDateAgenteScreen,
      agentDashboardFilter.finalDateAgentScreen,
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join()
    );
  }, [filtersDashboard]);
*/

  useEffect(() => {
    const sourceListDeal = axios.CancelToken.source();
    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsGroup = agentDashboardFilter.groupSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const page = pageOfTable + 1;

    let perfilNPS = "";
    const hasFiltersNPS =
      !!filtersNPS && Array.isArray(filtersNPS) && filtersNPS.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = filtersNPS.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }
    setPageOfTable(0);
    setPageOfTableCSAT(0);

    getAllData(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      1,
      rowsPage,
      searchData,
      sourceListDeal,
      perfilNPS,
      idsGroup
    );

    return () => {
      sourceListDeal.cancel("Operation canceled by the user. (sourceListDeal)");
    };
  }, [agentDashboardFilter]);

  const handleCloseDrawer = () => {
    setHiddenDrawerTreatment(false);
    setVisibleDrawerCase(false);
  };

  let checkSort = localStorage.getItem("sortDealingRow")
    ? JSON.parse(localStorage.getItem("sortDealingRow"))
    : "";

  let sortBy = {
    sortBy: [],
  };

  if (checkSort !== "") {
    sortBy = {
      sortBy: [
        {
          id: checkSort ? checkSort.sort : "agent",
          desc: checkSort ? checkSort.sortDesc : false,
        },
      ],
    };
  }

  function getTreatment() {
    const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;
    if (!hasTabs) {
      return treatmentData.find((item) => item.id_cdr === cdrId);
    }

    const hasOnlyOneTab = !!tabs && Array.isArray(tabs) && tabs.length === 1;
    const isOnlyNPS = hasOnlyOneTab && tabs[0].id === 1;
    //se tiver apenas NPS a pesquisa do dado para os Drawers apenas no dado do NPS
    if (isOnlyNPS) {
      return treatmentData.find((item) => item.id_cdr === cdrId);
    }

    //se tiver apenas CSAT a pesquisa do dado para os Drawers apenas no dado do CSAT
    const isOnlyCSAT = hasOnlyOneTab && tabs[0].id === 2;
    if (isOnlyCSAT) {
      return treatmentDataCSAT.find((item) => item.id_cdr === cdrId);
    }

    const isNPSAndCSAT = !!tabs && Array.isArray(tabs) && tabs.length === 2;

    if (isNPSAndCSAT) {
      //se possui os dois e o NPS está selecionada pega os dados da tabela de NPS

      const isNPSSelected = tabs[tabSelected].id === 1;
      if (isNPSSelected) {
        return treatmentData.find((item) => item.id_cdr === cdrId);
      }

      //se possui os dois e o CSAT está selecionada pega os dados da tabela de CSAT
      const isCSATSelected = tabs[tabSelected].id === 2;
      if (isCSATSelected) {
        return treatmentDataCSAT.find((item) => item.id_cdr === cdrId);
      }
    }

    return treatmentData.find((item) => item.id_cdr === cdrId);
  }

  //a depender da tab selecionada indentifica nos Drawers se o dado veio do CSAT ou NPS
  function selectType() {
    const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;
    if (!hasTabs) {
      return false;
    }

    const hasOnlyOneTab = !!tabs && Array.isArray(tabs) && tabs.length === 1;
    const isOnlyNPS = hasOnlyOneTab && tabs[0].id === 1;

    if (isOnlyNPS) {
      return false;
    }

    const isOnlyCSAT = hasOnlyOneTab && tabs[0].id === 2;
    if (isOnlyCSAT) {
      return true;
    }

    const isNPSAndCSAT = !!tabs && Array.isArray(tabs) && tabs.length === 2;

    if (isNPSAndCSAT) {
      const isNPSSelected = tabs[tabSelected].id === 1;
      if (isNPSSelected) {
        return false;
      }

      const isCSATSelected = tabs[tabSelected].id === 2;
      if (isCSATSelected) {
        return true;
      }
    }

    return false;
  }

  //a depender da tab selecionada ele passa qual a função deve ser usada ao excluir resposta no drawer
  function selectGetListDealOnClose() {
    const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;
    if (!hasTabs) {
      return updateListDealAfterTreatCaseOnClose;
    }

    const hasOnlyOneTab = !!tabs && Array.isArray(tabs) && tabs.length === 1;
    const isOnlyNPS = hasOnlyOneTab && tabs[0].id === 1;

    if (isOnlyNPS) {
      return updateListDealAfterTreatCaseOnClose;
    }

    const isOnlyCSAT = hasOnlyOneTab && tabs[0].id === 2;
    if (isOnlyCSAT) {
      return updateListDealAfterTreatCaseCSATOnClose;
    }

    const isNPSAndCSAT = !!tabs && Array.isArray(tabs) && tabs.length === 2;

    if (isNPSAndCSAT) {
      const isNPSSelected = tabs[tabSelected].id === 1;
      if (isNPSSelected) {
        return updateListDealAfterTreatCaseOnClose;
      }

      const isCSATSelected = tabs[tabSelected].id === 2;
      if (isCSATSelected) {
        return updateListDealAfterTreatCaseCSATOnClose;
      }
    }

    return updateListDealAfterTreatCaseOnClose;
  }

  // faz o mesmo que a função acima só que para o caso de aceitar e mudar status
  function selectGetListDeal() {
    const hasTabs = !!tabs && Array.isArray(tabs) && tabs.length > 0;
    if (!hasTabs) {
      return updateListDealAfterTreatCase;
    }

    const hasOnlyOneTab = !!tabs && Array.isArray(tabs) && tabs.length === 1;
    const isOnlyNPS = hasOnlyOneTab && tabs[0].id === 1;

    if (isOnlyNPS) {
      return updateListDealAfterTreatCase;
    }

    const isOnlyCSAT = hasOnlyOneTab && tabs[0].id === 2;
    if (isOnlyCSAT) {
      return updateListDealAfterTreatCaseCSAT;
    }

    const isNPSAndCSAT = !!tabs && Array.isArray(tabs) && tabs.length === 2;

    if (isNPSAndCSAT) {
      const isNPSSelected = tabs[tabSelected].id === 1;
      if (isNPSSelected) {
        return updateListDealAfterTreatCase;
      }

      const isCSATSelected = tabs[tabSelected].id === 2;
      if (isCSATSelected) {
        return updateListDealAfterTreatCaseCSAT;
      }
    }

    return updateListDealAfterTreatCase;
  }

  //função que define o que acontece ao mudar o filtro do csat
  function handleChangeChipsCSAT(selecteds, allChips, isToActiveAll) {
    const chipstoUpdate = allChips;
    const hasAllChips =
      !!allChips && Array.isArray(allChips) && allChips.length > 0;
    // se tiver tudo desativado ele ativa a opção Todos
    if (hasAllChips && isToActiveAll) {
      chipstoUpdate[0].active = true;
    }

    window.localStorage.setItem(
      "filterConceptDealingCSAT",
      JSON.stringify(chipstoUpdate)
    );
    setFiltersCSAT(chipstoUpdate);

    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");

    let perfilCSAT = "";
    const hasFiltersCSAT =
      !!chipstoUpdate &&
      Array.isArray(chipstoUpdate) &&
      chipstoUpdate.length > 0;
    if (hasFiltersCSAT) {
      const activesFiltersCSAT = chipstoUpdate.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersCSAT =
        !!activesFiltersCSAT &&
        Array.isArray(activesFiltersCSAT) &&
        activesFiltersCSAT.length > 0;
      if (hasActivesFiltersCSAT) {
        perfilCSAT = activesFiltersCSAT[0].id;
      }
    }

    const page = 1;
    setPageOfTableCSAT(page - 1);

    updateListDealV2CSAT(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      rowsPage,
      filter,
      perfilCSAT
    );
  }

  //função que define o que acontece ao mudar o filtro do NPS
  function handleChangeChipsNPS(selecteds, allChips, isToActiveAll) {
    const chipstoUpdate = allChips;
    const hasAllChips =
      !!allChips && Array.isArray(allChips) && allChips.length > 0;
    // se tiver tudo desativado ele ativa a opção Todos
    if (hasAllChips && isToActiveAll) {
      chipstoUpdate[0].active = true;
    }

    //salva o filtro selecionado no localStorage
    window.localStorage.setItem(
      "filterConceptDealingNPS",
      JSON.stringify(chipstoUpdate)
    );
    setFiltersNPS(chipstoUpdate);

    const dateStart = format(
      new Date(agentDashboardFilter.initialDateAgenteScreen),
      "yyyy-MM-dd"
    );
    const dateEnd = format(
      new Date(agentDashboardFilter.finalDateAgentScreen),
      "yyyy-MM-dd"
    );
    const idsChannel = agentDashboardFilter.channelSelectedAgentScreen
      .map((option) => option.id)
      .join(",");
    const idsAvaliation = agentDashboardFilter.avaliationSelectedAgentScreen
      .map((option) => option.id)
      .join(",");

    let perfilNPS = "";
    const hasFiltersNPS =
      !!chipstoUpdate &&
      Array.isArray(chipstoUpdate) &&
      chipstoUpdate.length > 0;
    if (hasFiltersNPS) {
      const activesFiltersNPS = chipstoUpdate.filter((datum) => {
        return datum.active;
      });
      const hasActivesFiltersNPS =
        !!activesFiltersNPS &&
        Array.isArray(activesFiltersNPS) &&
        activesFiltersNPS.length > 0;
      if (hasActivesFiltersNPS) {
        perfilNPS = activesFiltersNPS[0].id;
      }
    }

    const page = 1;
    setPageOfTable(page - 1);

    updateListDealV2(
      dateStart,
      dateEnd,
      idsChannel,
      idsAvaliation,
      page,
      rowsPage,
      filter,
      perfilNPS
    );
  }

  function renderContent() {
    //loading enquanto as tabs ainda estão sendo carregadas
    if (isLoadingTabs) {
      return (
        <div className="dealing-card-call-center__loading">
          <Paperplane />
        </div>
      );
    }

    const hasOnlyOneTab = !!tabs && Array.isArray(tabs) && tabs.length === 1;
    //caso tenha apenas o NPS
    const isOnlyNPS = hasOnlyOneTab && tabs[0].id === 1;
    if (isOnlyNPS) {
      return (
        <MenuTabs
          value={tabSelected}
          setValue={setTabSelected}
          tabs={[
            {
              label: "NPS",
              id: 1,
              content: (
                <div className="dealing-card__table-container">
                  <div className="dealing-card__table-container__filter dealing-card__table-container__filter--dealing-call-center">
                    <div className="dealing-card__table-container__filter--dealing-call-center__chips">
                      <span className="dealing-card__table-container__filter--dealing-call-center__chips__text">
                        Filtrar por perfil:
                      </span>
                      <FilterChips
                        onChange={handleChangeChipsNPS}
                        tags={filtersNPS}
                        setTags={setFiltersNPS}
                      />
                    </div>
                    <PopoverColumnsFilter
                      className={"filters-columns"}
                      placement="bottom-end"
                      menuData={exhibColumn}
                      screen="quality_agent_dealing"
                    >
                      <div className="email__container-subheader__actionsTwo">
                        <ColumnFilterIcon />
                        <span className="email__container-subheader__actionsTwo-span">
                          Colunas
                        </span>
                      </div>
                    </PopoverColumnsFilter>
                  </div>
                  <>
                    <TableBackPagination
                      fixedHeader
                      columns={tableColumns}
                      data={tableData}
                      className="dealing-inside-table dealing-table-call-center"
                      classDivWrapperTable="dealing-table-wrapper-table"
                      screen="npsTables"
                      initialState={sortBy}
                      totalOfRows={totalOfRows}
                      setRowsPage={setRowsPage}
                      rowsPage={rowsPage}
                      setPageOfTable={setPageOfTable}
                      pageOfTable={pageOfTable}
                      isloading={loading || isLoadingTabs}
                      onChangePage={(valueOfPage) => {
                        handleChangePage(valueOfPage);
                      }}
                      onChangeRowsPerPage={(valueOfRowsPerPage) => {
                        handleChangeRowsPerPage(valueOfRowsPerPage);
                      }}
                      isDisabled={loading || isLoadingTabs}
                    />
                  </>
                </div>
              ),
            },
          ]}
        />
      );
    }

    //caso tenha apenas CSAT
    const isOnlyCSAT = hasOnlyOneTab && tabs[0].id === 2;
    if (isOnlyCSAT) {
      return (
        <MenuTabs
          value={tabSelected}
          setValue={setTabSelected}
          tabs={[
            {
              label: "CSAT",
              id: 2,
              content: (
                <div className="dealing-card__table-container">
                  <div className="dealing-card__table-container__filter dealing-card__table-container__filter--dealing-call-center">
                    <div className="dealing-card__table-container__filter--dealing-call-center__chips">
                      <span className="dealing-card__table-container__filter--dealing-call-center__chips__text">
                        Filtrar por perfil:
                      </span>
                      <FilterChips
                        tagsInitialState={filtersCSAT}
                        onChange={handleChangeChipsCSAT}
                        tags={filtersCSAT}
                        setTags={setFiltersCSAT}
                      />
                    </div>
                    <PopoverColumnsFilter
                      className={"filters-columns"}
                      placement="bottom-end"
                      menuData={exhibColumn}
                      screen="quality_agent_dealing"
                    >
                      <div className="email__container-subheader__actionsTwo">
                        <ColumnFilterIcon />
                        <span className="email__container-subheader__actionsTwo-span">
                          Colunas
                        </span>
                      </div>
                    </PopoverColumnsFilter>
                  </div>
                  <>
                    <TableBackPagination
                      fixedHeader
                      columns={tableColumns}
                      data={tableDataCSAT}
                      className="dealing-inside-table dealing-table-call-center"
                      classDivWrapperTable="dealing-table-wrapper-table"
                      screen="npsTables"
                      initialState={sortBy}
                      totalOfRows={totalOfRowsCSAT}
                      setRowsPage={setRowsPage}
                      rowsPage={rowsPage}
                      setPageOfTable={setPageOfTableCSAT}
                      pageOfTable={pageOfTableCSAT}
                      isloading={loadingCSAT || isLoadingTabs}
                      onChangePage={(valueOfPage) => {
                        handleChangePageCSAT(valueOfPage);
                      }}
                      onChangeRowsPerPage={(valueOfRowsPerPage) => {
                        handleChangeRowsPerPageCSAT(valueOfRowsPerPage);
                      }}
                      isDisabled={loadingCSAT || isLoadingTabs}
                    />
                  </>
                </div>
              ),
            },
          ]}
        />
      );
    }

    //caso tenha ambos
    const isNPSAndCSAT = !!tabs && Array.isArray(tabs) && tabs.length === 2;
    if (isNPSAndCSAT) {
      return (
        <MenuTabs
          value={tabSelected}
          setValue={setTabSelected}
          tabs={[
            {
              label: "NPS",
              id: 1,
              content: (
                <div className="dealing-card__table-container">
                  <div className="dealing-card__table-container__filter dealing-card__table-container__filter--dealing-call-center">
                    <div className="dealing-card__table-container__filter--dealing-call-center__chips">
                      <span className="dealing-card__table-container__filter--dealing-call-center__chips__text">
                        Filtrar por perfil:
                      </span>
                      <FilterChips
                        onChange={handleChangeChipsNPS}
                        tags={filtersNPS}
                        setTags={setFiltersNPS}
                      />
                    </div>
                    <PopoverColumnsFilter
                      className={"filters-columns"}
                      placement="bottom-end"
                      menuData={exhibColumn}
                      screen="quality_agent_dealing"
                    >
                      <div className="email__container-subheader__actionsTwo">
                        <ColumnFilterIcon />
                        <span className="email__container-subheader__actionsTwo-span">
                          Colunas
                        </span>
                      </div>
                    </PopoverColumnsFilter>
                  </div>
                  <>
                    <TableBackPagination
                      fixedHeader
                      columns={tableColumns}
                      data={tableData}
                      className="dealing-inside-table dealing-table-call-center"
                      classDivWrapperTable="dealing-table-wrapper-table"
                      screen="npsTables"
                      initialState={sortBy}
                      totalOfRows={totalOfRows}
                      setRowsPage={setRowsPage}
                      rowsPage={rowsPage}
                      setPageOfTable={setPageOfTable}
                      pageOfTable={pageOfTable}
                      isloading={loading || isLoadingTabs}
                      onChangePage={(valueOfPage) => {
                        handleChangePage(valueOfPage);
                      }}
                      onChangeRowsPerPage={(valueOfRowsPerPage) => {
                        handleChangeRowsPerPage(valueOfRowsPerPage);
                      }}
                      isDisabled={loading || isLoadingTabs}
                    />
                  </>
                </div>
              ),
            },
            {
              label: "CSAT",
              id: 2,
              content: (
                <div className="dealing-card__table-container">
                  <div className="dealing-card__table-container__filter dealing-card__table-container__filter--dealing-call-center">
                    <div className="dealing-card__table-container__filter--dealing-call-center__chips">
                      <span className="dealing-card__table-container__filter--dealing-call-center__chips__text">
                        Filtrar por perfil:
                      </span>
                      <FilterChips
                        tagsInitialState={filtersCSAT}
                        onChange={handleChangeChipsCSAT}
                        tags={filtersCSAT}
                        setTags={setFiltersCSAT}
                      />
                    </div>
                    <PopoverColumnsFilter
                      className={"filters-columns"}
                      placement="bottom-end"
                      menuData={exhibColumn}
                      screen="quality_agent_dealing"
                    >
                      <div className="email__container-subheader__actionsTwo">
                        <ColumnFilterIcon />
                        <span className="email__container-subheader__actionsTwo-span">
                          Colunas
                        </span>
                      </div>
                    </PopoverColumnsFilter>
                  </div>
                  <>
                    <TableBackPagination
                      fixedHeader
                      columns={tableColumns}
                      data={tableDataCSAT}
                      className="dealing-inside-table dealing-table-call-center"
                      classDivWrapperTable="dealing-table-wrapper-table"
                      screen="npsTables"
                      initialState={sortBy}
                      totalOfRows={totalOfRowsCSAT}
                      setRowsPage={setRowsPage}
                      rowsPage={rowsPage}
                      setPageOfTable={setPageOfTableCSAT}
                      pageOfTable={pageOfTableCSAT}
                      isloading={loadingCSAT || isLoadingTabs}
                      onChangePage={(valueOfPage) => {
                        handleChangePageCSAT(valueOfPage);
                      }}
                      onChangeRowsPerPage={(valueOfRowsPerPage) => {
                        handleChangeRowsPerPageCSAT(valueOfRowsPerPage);
                      }}
                      isDisabled={loadingCSAT || isLoadingTabs}
                    />
                  </>
                </div>
              ),
            },
          ]}
        />
      );
    }

    return null;
  }

  return (
    <section className="dealing">
      <div className="dealing-card dealing-card-call-center">
        <header className="dealing-card-header">
          <div className="dealing-card-header__content">
            <Typography.H4 weight="700" color="gray-180">
              Tratativas
            </Typography.H4>

            <div className="dealing-card-header__content__input">
              <InputSearchBackPagination
                search={searchData}
                setSearch={setSearchData}
                onSearch={() => handleTableDataLookupV2(searchData)}
                onChange={(value) => {
                  handleChangeInputSearch(value);
                }}
                onKeyDown={true}
              />
            </div>
          </div>
        </header>
        {renderContent()}
      </div>

      {isDrawerOpen && (
        <UserTreatment
          isDrawerOpen={isDrawerOpen}
          setUserHistoryDrawer={setUserHistoryDrawer}
          onCloseDrawer={() => {
            setIsDrawerOpen(false);
            setCdrId(null);
          }}
          caseId={caseId}
          setCaseId={setCaseId}
          setIsDrawerOpen={setIsDrawerOpen}
          setVisibleDrawerComment={setVisibleDrawerComment}
          setVisibleDrawerCase={setVisibleDrawerCase}
          setUserInteractionDrawer={setUserInteractionDrawer}
          hiddenDrawerTreatment={hiddenDrawerTreatment}
          setHiddenDrawerTreatment={setHiddenDrawerTreatment}
          treatmentData={getTreatment()}
          getlistDeal={selectGetListDeal()}
          getListDealOnClose={selectGetListDealOnClose()}
          isCSAT={selectType()}
        />
      )}

      {visibleDrawerCase && (
        <div
          className="drawer-container"
          style={{ width: "49%", height: "100%", maxWidth: "650px" }}
        >
          <CaseDealing
            visibleDrawerCase={visibleDrawerCase}
            caseId={caseId}
            onCloseDrawer={() => handleCloseDrawer()}
            treatmentData={getTreatment()}
          />
        </div>
      )}

      {userHistoryDrawer && (
        <div className="drawer-container">
          <UserHistory
            userHistoryDrawer={userHistoryDrawer}
            onCloseDrawer={() => setUserHistoryDrawer(false)}
            treatmentData={getTreatment()}
            isCSAT={selectType()}
          />
        </div>
      )}

      {userInteractionDrawer && (
        <div className="drawer-container">
          <UserInteraction
            userInteractionDrawer={userInteractionDrawer}
            onCloseDrawer={() => setUserInteractionDrawer(false)}
            treatmentData={getTreatment()}
          />
        </div>
      )}

      {visibleDrawerComment && (
        <div className="drawer-container">
          <Comment
            visibleDrawerComment={visibleDrawerComment}
            onCloseDrawer={() => setVisibleDrawerComment(false)}
            treatmentData={getTreatment()}
            dataMsg={dataMsg}
            setDataMsg={setDataMsg}
          />
        </div>
      )}
    </section>
  );
};

export default Dealing;
